import React from 'react';
import PropTypes from 'prop-types';

export const saleTagColor = '#c0392b';
const fontSize = 12;

export const defaultStyles = {
  saleTagContainer: {
    position: 'relative',
  },
  saleTag: {
    backgroundColor: saleTagColor,
    color: '#FFF',
    top: -4,
    left: -17,
    padding: '2px 10px',
    position: 'absolute',
    fontWeight: 100,
    fontSize: fontSize - 2,
  },
};

export default function SaleTag(props) {
  const { calculatedPricing, styles } = props;

  if (!calculatedPricing) {
    return null;
  }

  if (calculatedPricing.onSale) {
    return (
      <div style={styles.saleTagContainer}>
        <div style={styles.saleTag}>SALE!</div>
      </div>
    );
  }
  return null;
}

SaleTag.propTypes = {
  calculatedPricing: PropTypes.shape({
    onSale: PropTypes.bool,
  }).isRequired,
  styles: PropTypes.shape({
    saleTagContainer: PropTypes.shape({}),
    saleTag: PropTypes.shape({}),
  }),
};

SaleTag.defaultProps = {
  styles: defaultStyles,
};
